export const UserInfoMixin = {

  methods: {

    twnPhoneFormat(phone) {
      if (!phone || !phone.length) return '';
      let match = phone.match(/\+8869\d{8}/g);
      if (match && match[0] === phone)
        return phone.replace('+8869', '09');
      return phone;
    },

    // censorName(name) {
    //   if (this.$store.getters.cheatMode) return name;
    //   let ascii = /^[ -~]+$/;
    //   let ret = '';
    //   if (ascii.test(name.substr(0, 2))) {//If there're no non-ascii characters in the name...
    //     let maskStart = Math.ceil(name.length * 0.4);
    //     ret = name.substr(0, maskStart);
    //     for (let i=maskStart; i<name.length-1; i++) ret += '*';
    //     ret += name.charAt(name.length - 1);
    //   }
    //   else {//Otherwise...
    //     if (name.length == 1) ret = `＊`;
    //     else if (name.length == 2) ret = `${name.charAt(0)}＊`;
    //     else {
    //       ret = name.substr(0, 1); 
    //       for (let i=1; i<name.length-1; i++) ret += '＊';
    //       ret += name.charAt(name.length - 1);
    //     }
    //   }
    //   return ret;
    // },
    censorPhone(phone) {
      if (this.$store.getters.cheatMode) return phone;
      if (!phone) return `（無電話號碼）`;
      return `${phone.substr(0, 4)}***${phone.substr(7, 3)}`;
    },
    // censorEmail(email) {
    //   if (this.$store.getters.cheatMode) return email;
    //   let atIndex = email.indexOf('@');
    //   let maskLength = Math.ceil(0.6 * atIndex);
    //   let mask = '';
    //   for (let i=0; i<maskLength; i++) mask += '*';
    //   return `${email.substr(0, atIndex - maskLength)}${mask}${email.substring(atIndex)}`;
    // }

  }
  
};